
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.34 21.971c-1.683.001-3.151-1.288-3.29-2.98-.002-.033-.01-.141-.008-5.998-.038-.82.26-1.636.841-2.27a3.363 3.363 0 012.356-1.088c.094-.006 2.85 0 4.688.003l.89.002c1.79-.126 3.407 1.204 3.551 2.988.001.018.003.122.004.311l1.653-1.354a1.579 1.579 0 011.689-.206c.561.267.91.818.909 1.439l-.01 5.85c0 .62-.35 1.171-.91 1.436a1.581 1.581 0 01-1.688-.209l-1.64-1.347v.057c.034.84-.266 1.65-.844 2.279a3.36 3.36 0 01-2.357 1.083c-.09.007-2.633.001-4.464-.003l-1.117-.002c-.085.006-.17.01-.253.01zm.558-11.144c-.35 0-.575 0-.614.002a2.172 2.172 0 00-1.52.7 1.981 1.981 0 00-.528 1.437c0 2.303 0 5.76.006 5.949.09 1.102 1.124 1.945 2.307 1.854l1.601.003c1.898.003 3.865.007 3.983.002a2.17 2.17 0 001.519-.698c.365-.397.553-.907.53-1.433v-.026c0-2.277 0-5.73-.006-5.916-.09-1.108-1.127-1.962-2.317-1.868-1.644-.003-3.888-.006-4.961-.006zm8.478 6.176l-.001-2.524 2.406-1.97a.387.387 0 01.421-.051.385.385 0 01.227.358l-.01 5.85a.384.384 0 01-.226.357.384.384 0 01-.422-.05l-2.395-1.97z","fill":"#A4A8C0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zM1.433 16C1.433 7.955 7.955 1.433 16 1.433S30.567 7.955 30.567 16 24.045 30.567 16 30.567 1.433 24.045 1.433 16z","fill":"#A4A8C0"}})])
          )
        }
      }
    